module.exports = __webpack_public_path__ + "img/spot.083eafd2.png";